import {
    faCheck,
    faEdit,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
    DeletarEmailContaController,
    ListarEmailContaController,
    ValidarEmailController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import { IEmailConta } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { Spinner } from "../../../../../Loding/SpinnerPadrao";
import ModalComponent from "../../../../../Modais";
import { IComponentModal } from "../../../../../Modais/IModalComponent";
import Table from "../../../../../Table";
import OrSpinner from "../../../../../Utils/OrSpinner";
import ConfiguracaoEmailReceptivo from "./ConfiguracaoEmailReceptivo";
import ModalCadastrarEmailConta from "./ModalCadastrarEmailConta";
import ModalEditarEmailConta from "./ModalEditarEmailConta";
import Swal from "sweetalert2";

export interface ModalEditarEmailPropsInterface {
    ID_EMAIL_CONTA: number;
    updateList: () => void;
}

export interface ModalCadastratEmailPropsInterface {
    updateList: () => void;
    setShow: (show: boolean) => void;
    listaEmail?: IEmailConta[] | undefined;
}

export default function EmailConta() {
    const [show, setShow] = useState<boolean>(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { execute: validarEmail, loading: validarEmailLoading } =
        useAsyncCallback(ValidarEmailController);

    const { execute: DeletarEmailConta, loading: DeletarEmailContaLoading } =
        useAsyncCallback(DeletarEmailContaController);

    const {
        value: listaEmail,
        loading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarEmailContaController();
    }, []);

    const ColunsEmail = [
        {
            dataField: "DS_USERNAME",
            text: "E-mail",
            formatter: RowTableEmail,
            sort: true,
        },
    ];

    function RowTableEmail(cell: any, row: IEmailConta) {
        return (
            <div className="rowCapysTR d-flex justify-content-between align-items-center">
                <div>
                    <label className="mb-1">{row.DS_USERNAME}</label>

                    <div>
                        {row.DS_REMETENTE && (
                            <span
                                className={`label abel-pill label-inline label-primary`}
                            >
                                {row.DS_REMETENTE}
                            </span>
                        )}
                        {row.FL_SSL ? (
                            <span className="label abel-pill label-inline label-success ml-2">
                                {" "}
                                SSL{" "}
                            </span>
                        ) : null}
                        {row.FL_VALIDADO ? (
                            <span className="label abel-pill label-inline label-success ml-2">
                                {" "}
                                Válido{" "}
                            </span>
                        ) : (
                            <span className="label abel-pill label-inline label-danger ml-2">
                                {" "}
                                Não Válido{" "}
                            </span>
                        )}
                    </div>
                </div>
                <div>
                    <div className="Button-Tools">
                        <button
                            className="btn btn-outline-warning font-weight-bold mr-2"
                            onClick={() => {
                                validarEmail(row.ID_EMAIL_CONTA).then(
                                    updateList
                                );
                            }}
                            disabled={validarEmailLoading}
                        >
                            {validarEmailLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faCheck} size="lg" />{" "}
                                </>
                            )}
                            <span>Validar</span>
                        </button>
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () =>
                                        ModalEditarEmailConta({
                                            ID_EMAIL_CONTA: row.ID_EMAIL_CONTA,
                                            updateList,
                                        }),
                                    headerComponent:
                                        "Configuração de Conta de E-mail",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </button>
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2"
                            disabled={DeletarEmailContaLoading}
                            onClick={() => {
                                Swal.fire({
                                    title: "Deseja apagar este email conta?",
                                    icon: "info",
                                    buttonsStyling: false,
                                    confirmButtonText:
                                        "<i class='la la-check'></i> Sim!",
                                    showCancelButton: true,
                                    cancelButtonText:
                                        "<i class='la la-thumbs-down'></i> Não",
                                    customClass: {
                                        confirmButton:
                                            "btn btn-outline-success",
                                        cancelButton: "btn btn-default",
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        DeletarEmailConta(
                                            row.ID_EMAIL_CONTA
                                        ).then((response) => {
                                            updateList();
                                        });
                                    }
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <OrSpinner spinner="capys" loading={loading}>
            {" "}
            {listaEmail && (
                <>
                    <div className="card card-custom" id="kt_page_sticky_card">
                        <div className="card-header card-header-tabs-line">
                            <div className="card-toolbar">
                                <ul className="nav nav-tabs nav-bold nav-tabs-line">
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            data-toggle="tab"
                                            href="#EmailConta"
                                        >
                                            <span className="nav-icon">
                                                <i className="flaticon-interface-3"></i>
                                            </span>
                                            <span className="nav-text">
                                                Email Conta
                                            </span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#EmailReceptivo"
                                        >
                                            <span className="nav-icon">
                                                <i className="flaticon2-chat-1"></i>
                                            </span>
                                            <span className="nav-text">
                                                Email Receptivo
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card-body tab-content">
                            <div
                                className="tab-pane fade show active"
                                id="EmailConta"
                                role="tabpanel"
                                aria-labelledby="EmailConta"
                            >
                                <div className="border-0 d-flex justify-content-between align-items-center p-0">
                                    <h5 className="card-title align-items-start flex-column m-0">
                                        <span className="card-label font-weight-bolder text-dark">
                                            Configuração E-mail Conta
                                        </span>
                                    </h5>
                                    <div className="card-toolbar">
                                        <button
                                            className="btn btn-success font-weight-bold mr-2"
                                            onClick={() => {
                                                setShow(true);
                                                setModal({
                                                    Component: () =>
                                                        ModalCadastrarEmailConta(
                                                            {
                                                                setShow,
                                                                updateList,
                                                                listaEmail:
                                                                    listaEmail,
                                                            }
                                                        ),
                                                    noHeader: true,
                                                    noFooter: true,
                                                });
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faPlus}
                                                size="lg"
                                                className="mr-2"
                                            />{" "}
                                            Novo E-mail
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body p-0 mt-5">
                                    <div className="table-responsive-sm">
                                        <Table
                                            noDataIndication={
                                                <div className="text-black-50 text-center">
                                                    Nenhum Atendimento
                                                    encontrado
                                                </div>
                                            }
                                            keyField="ID_EMAIL_CONTA"
                                            data={listaEmail}
                                            columns={ColunsEmail}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade show"
                                id="EmailReceptivo"
                                role="tabpanel"
                                aria-labelledby="EmailReceptivo"
                            >
                                <ConfiguracaoEmailReceptivo />
                            </div>
                        </div>

                        <ModalComponent
                            show={show}
                            setShow={setShow}
                            ModalComponent={modal}
                        />
                    </div>
                </>
            )}
        </OrSpinner>
    );
}
